import script from "./FullPageLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./FullPageLoader.vue?vue&type=script&setup=true&lang=js"

import "./FullPageLoader.vue?vue&type=style&index=0&id=41878fe6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41878fe6"]])

export default __exports__